import _createForOfIteratorHelper from "/builds/9xb/sites/peracto3/jigsaw24services/jigsaw24.com/peracto.jigsaw24.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _slicedToArray from "/builds/9xb/sites/peracto3/jigsaw24services/jigsaw24.com/peracto.jigsaw24.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function e() {
  var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  for (var _i = 0, _Object$entries = Object.entries(n); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        i = _Object$entries$_i[0],
        o = _Object$entries$_i[1];

    f(t, s(r, i), o);
  }

  return t;
}

function s(n, r) {
  return n ? n + "[" + r + "]" : r;
}

function f(n, r, t) {
  if (Array.isArray(t)) {
    var _iterator = _createForOfIteratorHelper(t.entries()),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
            i = _step$value[0],
            o = _step$value[1];

        f(n, s(r, i.toString()), o);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  } else t instanceof Date ? n.push([r, t.toISOString()]) : typeof t == "boolean" ? n.push([r, t ? "1" : "0"]) : typeof t == "string" ? n.push([r, t]) : typeof t == "number" ? n.push([r, "".concat(t)]) : t == null ? n.push([r, ""]) : e(t, r, n);
}

function p(n) {
  var t;
  var r = (t = n == null ? void 0 : n.form) != null ? t : n.closest("form");

  if (!!r) {
    var _iterator2 = _createForOfIteratorHelper(r.elements),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var i = _step2.value;

        if (i.tagName === "INPUT" && i.type === "submit" || i.tagName === "BUTTON" && i.type === "submit" || i.nodeName === "INPUT" && i.type === "image") {
          i.click();
          return;
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
}

export { p as attemptSubmit, e as objectToFormEntries };